module.exports = __webpack_public_path__ + "img/オルコ・パチャ.b3a89790.png";